import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMute: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"mute, sound-off"} maskId="square-filled-radius-0-stroke-1-IconMute"><path d="M3.50008 21.2072L21.2072 3.50008L20.5001 2.79297L17 6.29305V2.88477L9.86611 7.00047H5V17.0005H6.29257L2.79297 20.5001L3.50008 21.2072Z" fill="currentColor"/><path d="M9.86611 17.0005H9.12155L17 9.12202V21.1162L9.86611 17.0005Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMute;
